<template>
  <v-container fluid>
    <h3>Arqueo de caja</h3>
    <hr class="mt-1 mb-3"/>

    <v-card class="mb-3">
      <v-card-title>Filtros</v-card-title>

      <v-card-text class="pb-0">
        <v-row align="center" dense>

          <v-col cols="12" md="3">
            <date-input hide-details outlined label="Fecha" v-model="date" @input="fetch"
                        :clearable="false"></date-input>
          </v-col>

          <v-col cols="12" md="3">
            <v-select outlined hide-details v-model="shift" label="Turno" :items="shifts"
                      @change="fetch"></v-select>
          </v-col>

          <v-col cols="12" md="3">
            <div>
              <v-chip><b>Desde</b>: {{ dateFrom.format('YYYY-MM-DD HH:mm') }}</v-chip>
              <v-chip><b>Hasta</b>: {{ dateTo.format('YYYY-MM-DD HH:mm') }}</v-chip>
            </div>

          </v-col>
          <v-col cols="12" md="3">
            <v-chip><b>Ordenes</b>: {{ getOrdersQuantity }} (${{ getOrdersAmount.toFixed(0) }})</v-chip>
          </v-col>
        </v-row>
      </v-card-text>

      <!--INCOME/EXPENSES-->
      <v-card-title>Registros Adicionales</v-card-title>
      <v-card-text class="pb-0">

        <v-simple-table dense>
          <tbody>


          <tr v-for="(income,index) in dailyBox.income" :key="'income_'+index">
            <th class="pt-2 pb-2">
              <v-text-field background-color="blue lighten-4" dense outlined hide-details
                            label="Concepto Ingreso" v-model="income.concept"
                            @change="debounceBox"></v-text-field>
            </th>
            <th class="pt-2 pb-2">
              <v-text-field type="number" background-color="blue lighten-4" dense outlined hide-details
                            label="Monto Ingreso"
                            @change="debounceBox"
                            v-model.number="income.amount"></v-text-field>
            </th>
            <td>
              <v-btn icon @click="removeIncome(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>

          <tr v-for="(expense,index) in dailyBox.expenses" :key="'expense_'+index">
            <th class="pt-2 pb-2">
              <v-text-field background-color="red lighten-4" dense outlined hide-details
                            label="Concepto Egreso" v-model="expense.concept"
                            @change="debounceBox"></v-text-field>
            </th>
            <th class="pt-2 pb-2">
              <v-text-field background-color="red lighten-4" type="number" dense outlined hide-details
                            label="Monto Egreso"
                            @change="debounceBox"
                            v-model.number="expense.amount"></v-text-field>
            </th>
            <td>
              <v-btn icon @click="removeExpenses(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>


          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue white--text" small @click="addIncome">Agregar Ingreso</v-btn>
        <v-btn color="red white--text" small @click="addExpense">Agregar Egreso</v-btn>
      </v-card-actions>

    </v-card>

    <v-card>
      <v-card-title>Resumen</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="3">
            <v-card outlined>
              <v-card-title>Ordenes</v-card-title>
              <v-card-text class="text-h4 text-center">{{ ordersLength }}</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="3">
            <dashboard-card
                title="Productos"
                :quantity="totalProductQuantity"
                :amount="totalProductAmount"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="3">

            <dashboard-card
                title="Promos"
                :quantity="totalPromoQuantity"
                :amount="totalPromoAmount"
            />

          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3">
            <dashboard-card
                title="Descuentos"
                :quantity="totalDiscountQuantity"
                :amount="totalDiscountAmount"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="3">
            <dashboard-card
                title="Delivery"
                :quantity="deliveryQuantity"
                :amount="ordersTotalDeliveryAmount"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="3">
            <dashboard-card
                title="Delivery Propio"
                :quantity="ordersOwnLength"
                :amount="ordersOwnAmount"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="3">
            <dashboard-card
                title="Delivery Terceros"
                :quantity="ordersOutsourcedLength"
                :amount="ordersOutsourcedAmount"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" lg="3">
            <dashboard-card
                title="Delivery Bonificado"
                :quantity="deliveryFreeQuantity"
                :amount="totalDeliveryFree"
            />

          </v-col>

          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card outlined>
              <v-card-title>Total Turno</v-card-title>
              <v-card-subtitle>Productos + Promos + Delivery Terceros - Descuentos</v-card-subtitle>
              <v-card-text class="text-h4 text-center">{{ currencyFormat(totalShiftAmount) }}</v-card-text>
            </v-card>
          </v-col>

        </v-row>

      </v-card-text>
    </v-card>


    <!--    <v-card class="mt-2">-->
    <!--      <v-card-title>Resumen</v-card-title>-->
    <!--      <v-card-text>-->

    <!--        <v-simple-table>-->
    <!--          <tbody>-->
    <!--          <tr>-->
    <!--            <th>Total Facturado:</th>-->
    <!--            <td>{{ currencyFormat(totalShiftAmount) }}</td>-->
    <!--            <th>Ordenes:</th>-->
    <!--            <td>{{ ordersLength }}</td>-->
    <!--          </tr>-->
    <!--          <tr>-->
    <!--            <th>Productos:</th>-->
    <!--            <td>{{ currencyFormat(totalProductAmount) }}</td>-->
    <!--            <th>Promos:</th>-->
    <!--            <td>{{ currencyFormat(totalPromoAmount) }}</td>-->
    <!--          </tr>-->
    <!--          <tr>-->
    <!--            <th>Descuento Productos:</th>-->
    <!--            <td>{{ currencyFormat(totalDiscountAmount) }}</td>-->
    <!--            <th>Delivery Bonificado:</th>-->
    <!--            <td>{{ currencyFormat(totalDeliveryFree) }}</td>-->
    <!--          </tr>-->


    <!--          <tr>-->
    <!--            <th>Productos + Promo:</th>-->
    <!--            <td>{{ currencyFormat(totalProductAmount + totalPromoAmount) }}</td>-->
    <!--            <th>Total Descuentos:</th>-->
    <!--            <td>{{ currencyFormat(totalDiscountAmount + totalDeliveryFree) }}</td>-->
    <!--          </tr>-->

    <!--          <tr>-->
    <!--            <th>Delivery:</th>-->
    <!--            <td>{{ currencyFormat(ordersOutsourcedAmount + ordersOwnAmount) }}</td>-->
    <!--            <th>Cantidad Delivery:</th>-->
    <!--            <td>{{ ordersOutsourcedLength + ordersOwnLength }}</td>-->
    <!--          </tr>-->

    <!--          <tr>-->
    <!--            <th>Monto Delivery Tercerizado:</th>-->
    <!--            <td>{{ currencyFormat(ordersOutsourcedAmount) }}</td>-->
    <!--            <th>Cantidad Delivery Tercerizado:</th>-->
    <!--            <td>{{ ordersOutsourcedLength }}</td>-->
    <!--          </tr>-->
    <!--          <tr>-->
    <!--            <th>Monto Delivery Propio:</th>-->
    <!--            <td>{{ currencyFormat(ordersOwnAmount) }}</td>-->
    <!--            <th>Cantidad Delivery Propio:</th>-->
    <!--            <td>{{ ordersOwnLength }}</td>-->
    <!--          </tr>-->
    <!--          </tbody>-->
    <!--        </v-simple-table>-->

    <!--      </v-card-text>-->
    <!--    </v-card>-->

    <loading v-if="loading"></loading>

    <v-card class="mt-2" v-if="!loading && orders.length > 0">
      <v-card-title>EFECTIVO</v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
          <tr>
            <th>Concepto</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>

          <!--EFECTIVO TURNO ANTERIOR-->
          <tr>
            <th class="blue lighten-3">Efectivo inicial de caja</th>
            <td class="blue lighten-3">{{ currencyFormat(previousCashAtClose) }}</td>
          </tr>

          <!--EFECTIVO-->
          <tr>
            <th class="blue lighten-3">Efectivo mostrador</th>
            <td class="blue lighten-3">{{ currencyFormat(cashOnBar) }}</td>
          </tr>


          <tr v-for="(row,index) in boxRows" :key="index">
            <th :class="{red: row.amount < 0, blue: row.amount > 0}" class="lighten-4">{{ row.concept }}</th>
            <td :class="{red: row.amount < 0, blue: row.amount > 0}" class="lighten-4">{{
                currencyFormat(row.amount)
              }}
            </td>
          </tr>

          <!--TOTAL-->
          <tr>
            <th>Total</th>
            <td>{{ currencyFormat(getTotalCashAmount) }}</td>
          </tr>

          <tr>
            <th>Efectivo en caja verificado (al Cierre)</th>
            <td>
              <v-text-field type="number" class="my-2"
                            label="Efectivo en caja verificado (al Cierre)" outlined hide-details dense
                            @change="debounceBox"
                            v-model.number="dailyBox.cashAtClose"
              />
            </td>
          </tr>
          <tr>
            <th>Diferencia</th>
            <td>{{ currencyFormat(dailyBox.cashAtClose - getTotalCashAmount) }}</td>
          </tr>

          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-title>Pagos Electrónicos</v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
          <tr>
            <th>Concepto</th>
            <th>Cantidad</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>Debito</th>
            <td>{{ debito.quantity }}</td>
            <td>{{ currencyFormat(debito.totalAmount) }}</td>
          </tr>
          <tr>
            <th>Transferencias Bancarias</th>
            <td>{{ transferenciaBancaria.quantity }}</td>
            <td>{{ currencyFormat(transferenciaBancaria.totalAmount) }}</td>
          </tr>
          <tr>
            <th>Transferencias Mercado Pago</th>
            <td>{{ transferenciaMercadoPago.quantity }}</td>
            <td>{{ currencyFormat(transferenciaMercadoPago.totalAmount) }}</td>
          </tr>
          <tr>
            <th>Rappi</th>
            <td>{{ transferenciaRappi.quantity }}</td>
            <td>{{ currencyFormat(transferenciaRappi.totalAmount) }}</td>
          </tr>
          <tr>
            <th>PedidosYa</th>
            <td>{{ transferenciaPedidosYa.quantity }}</td>
            <td>{{ currencyFormat(transferenciaPedidosYa.totalAmount) }}</td>
          </tr>

          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="print" color="primary">
          <v-icon left>print</v-icon>
          Imprimir
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2" v-if="!loading && orders.length > 0">
      <v-card-title>Reporte detallado</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-tabs vertical v-model="tabs">
              <v-tab v-for="deliveryUser in getDeliveryUsers" :key="deliveryUser">
                <span>{{ deliveryUser ? deliveryUser : 'Mostrador' }}</span>
                <v-spacer></v-spacer>
                <span>{{ getOrdersQuantityByUser(deliveryUser) }} (${{
                    getOrdersAmountByUser(deliveryUser).toFixed(0)
                  }})</span>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" sm="8">
            <v-tabs-items v-model="tabs">
              <v-tab-item v-for="deliveryUser in getDeliveryUsers" :key="deliveryUser">
                <order-report-detail
                    :delivery-user="deliveryUser"
                    :report="getReportByUser(deliveryUser)"
                    :orders="getOrdersByUser(deliveryUser)"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-alert v-else type="info">
      Sin datos para la fecha seleccionada
    </v-alert>

  </v-container>
</template>

<script>
import {DateInput, Dayjs, DayjsMixin} from "@dracul/dayjs-frontend"
import {Loading} from "@dracul/common-frontend";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import CashAuditProvider from "@/modules/delivery/providers/CashAuditProvider";
import OrderReportDetail from "@/modules/delivery/components/OrderReportDetail";
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";
import {userProvider} from "@dracul/user-frontend";
import DailyBoxProvider from "@/modules/delivery/providers/DailyBoxProvider";
import debounce from 'lodash.debounce';
import DashboardCard from "@/modules/delivery/components-core/business/DashboardCard/DashboardCard.vue";

export default {
  name: "ArqueoReportPage",
  components: {DashboardCard, OrderReportDetail, DateInput, Loading},
  mixins: [CurrencyMixin, DayjsMixin],
  data() {
    return {
      loading: false,
      shifts: [
        {value: 'morning', text: 'Mañana'},
        {value: 'afternoon', text: 'Tarde'},
      ],
      date: Dayjs().startOf('day'),
      shift: null,
      morningShiftHour: 7,
      afternoonShiftHour: 16,
      orders: [],
      tabs: null,
      exportLoading: false,
      exportFile: null,
      ownDeliveryPeople: [],
      outsourcedDeliveryPeople: [],
      bills: [{concept: '', amount: 0}],
      dailyBox: {
        boxDate: Dayjs().startOf('day'),
        shift: null,
        income: [],
        expenses: [],
        cashAtClose: 0,
      },
      previousDailyBox: {
        boxDate: null,
        shift: null,
        income: [],
        expenses: [],
        cashAtClose: 0,
      },
      debounceBox: null,
      delay: 500
    }
  },
  created() {
    this.debounceBox = debounce(this.createOrUpdateDailyBox, this.delay)
    this.currentShift()
    this.fetchDailyBox()
    this.fetchPreviousDailyBox()
    this.fetchOwnDelivery()
    this.fetchOutsourcedDelivery()
    this.fetchOrders()
  },
  computed: {

    ordersLength() {
      return this.orders.length
    },
    ordersOutsourcedLength() {
      return this.getOrderOutsourced.length
    },
    ordersOwnLength() {
      return this.getOrderOwn.length
    },
    ordersTotalDeliveryAmount() {
      return this.ordersOutsourcedAmount + this.ordersOwnAmount - this.totalDeliveryFree
    },
    ordersOutsourcedAmount() {
      return this.getOrderOutsourced.reduce((total, order) => total + order.delivery.cost, 0)
    },
    ordersOwnAmount() {
      return this.getOrderOwn.reduce((total, order) => total + order.delivery.cost, 0)
    },
    getOrderOutsourced() {
      return this.orders.filter(order => order.delivery.mode === 'DELIVERY' &&
          order.deliveryUser && this.outsourcedDeliveryPeople.some(u => u.username === order.deliveryUser.username))
    },
    getOrderOwn() {
      return this.orders.filter(order => order.delivery.mode === 'DELIVERY' &&
          order.deliveryUser && this.ownDeliveryPeople.some(u => u.username === order.deliveryUser.username))
    },
    totalAmount() {
      return this.orders.reduce((total, order) => total + order.totalAmount, 0)
    },
    totalShiftAmount() {
      return this.totalProductAmount + this.totalPromoAmount + this.ordersOutsourcedAmount - this.totalDiscountAmount
    },
    totalProductAmount() {
      return this.orders.reduce((total, order) => total + order.itemsAmount, 0)
    },
    totalProductQuantity() {
      return this.orders.reduce((total, order) => total + (order.items ? order.items.reduce((a, i) => a + i.quantity, 0) : 0), 0)
    },
    totalPromoAmount() {
      return this.orders.reduce((total, order) => total + order.promoAmount, 0)
    },
    totalPromoQuantity() {
      return this.orders.reduce((total, order) => total + (order.promos ? order.promos.length : 0), 0)
    },
    totalDiscountAmount() {
      return this.orders.reduce((total, order) => total + order.totalDiscount, 0)
    },
    totalDiscountQuantity() {
      return this.orders.filter((order) => order.totalDiscount > 0).length
    },
    totalDeliveryFree() {
      return this.orders.filter(o => o.delivery.mode === "DELIVERY").reduce((total, order) => total + (order.deliveryFree ? order.delivery.cost : 0), 0)
    },
    deliveryFreeQuantity() {
      return this.orders.filter(o => o.delivery.mode === "DELIVERY" && o.deliveryFree).length
    },
    deliveryQuantity() {
      return this.orders.filter(o => o.delivery.mode === "DELIVERY").length
    },
    previousShift() {
      if (this.shift === 'morning') {
        return 'afternoon'
      } else {
        return 'morning'
      }
    },
    previousDate() {
      if (this.previousShift === 'afternoon') {
        return this.date.subtract(1, 'day')
      } else {
        return this.date
      }
    },
    boxRows() {
      let rows = []

      //rows.push({concept: 'Efectivo en caja' , amount: this.cashOnBar })

      this.getOwnDeliveryPeople.forEach(ownDeliveryPerson => {
        rows.push({
          concept: `Efectivo Productos - Repartidor propio (${ownDeliveryPerson.username})`,
          amount: parseInt(this.getReportByUserAndMethod(ownDeliveryPerson.username, 'CASH').itemsAmountWithDiscount)
        })
        rows.push({
          concept: `Costo Envío Transferencia - Repartidor propio (${ownDeliveryPerson.username})`,
          amount: -(parseInt(this.getReportByUserAndMethod(ownDeliveryPerson.username, 'BANK_TRANSFER').deliveryCost))
        })
        rows.push({
          concept: `Costo Envío Mercado Pago - Repartidor propio (${ownDeliveryPerson.username})`,
          amount: -(parseInt(this.getReportByUserAndMethod(ownDeliveryPerson.username, 'MP_TRANSFER').deliveryCost))
        })
      })
      this.getOutsourcedDeliveryPeople.forEach(outsourcedDeliveryPerson => {
        rows.push({
          concept: `Efectivo Total - Repartidor Tercerizado (${outsourcedDeliveryPerson.username})`,
          amount: parseInt(this.getReportByUserAndMethod(outsourcedDeliveryPerson.username, 'CASH').totalAmount)
        })
      })

      this.dailyBox.income.forEach(income => {
        rows.push({concept: income.concept, amount: income.amount})

      })

      this.dailyBox.expenses.forEach(expense => {
        rows.push({concept: expense.concept, amount: -(expense.amount)})
      })

      return rows

    },
    getTotalCashAmount() {
      return this.cashOnBar + this.previousCashAtClose + this.getBoxRowsAmount
    },
    getBoxRowsAmount() {
      return this.boxRows.reduce((total, row) => total + row.amount, 0)
    },
    debito() {
      return this.getReportByMethod('DEBIT')
    },
    transferenciaBancaria() {
      return this.getReportByMethod('BANK_TRANSFER')
    },
    transferenciaMercadoPago() {
      return this.getReportByMethod('MP_TRANSFER')
    },
    transferenciaRappi() {
      return this.getReportByMethod('RAPPI')
    },
    transferenciaPedidosYa() {
      return this.getReportByMethod('PEDIDOS_YA')
    },

    getBills() {
      return this.bills.filter(bill => bill.amount > 0)
    },
    getOwnDeliveryPeople() {
      return this.ownDeliveryPeople.filter(u => this.orders.some(o => o.deliveryUser && o.deliveryUser.username === u.username))
    },
    getOutsourcedDeliveryPeople() {
      return this.outsourcedDeliveryPeople.filter(u => this.orders.some(o => o.deliveryUser && o.deliveryUser.username === u.username))
    },
    dateFrom() {
      if (this.shift == 'morning') {
        return this.date.clone().startOf('day').add(this.morningShiftHour, 'hours')
      }
      if (this.shift == 'afternoon') {
        return this.date.clone().startOf('day').add(this.afternoonShiftHour, 'hours')
      }
      return this.date.startOf('day')
    },
    dateTo() {
      if (this.shift == 'morning') {
        return this.date.clone().startOf('day').add(this.afternoonShiftHour, 'hours')
      }
      if (this.shift == 'afternoon') {
        return this.date.clone().startOf('day').add(1, 'day').add(this.morningShiftHour, 'hours')
      }

      return this.date.startOf('day')
    },
    cashOnBar() {
      return this.orders.reduce((a, order) => {
        if (!order.deliveryUser && order.payment.method === 'CASH') {
          return a + order.totalAmount
        } else {
          return a
        }
      }, 0)
    },
    previousCashAtClose() {
      return this.previousDailyBox?.cashAtClose ? this.previousDailyBox?.cashAtClose : 0
    },
    getDeliveryUsers() {
      return this.orders.reduce((a, v) => {
        if (v.deliveryUser && !a.includes(v.deliveryUser.username))
          a.push(v.deliveryUser.username)
        return a
      }, [''])
    },
    getOrdersByUser() {
      return deliveryUser => {
        return this.orders.filter(o => (!deliveryUser && !o.deliveryUser) || (o.deliveryUser && o.deliveryUser.username === deliveryUser))
      }
    },
    getOrdersByUserAndMethod() {
      return (deliveryUser, method) => {
        return this.orders.filter(o => (
            o.deliveryUser && o.deliveryUser.username === deliveryUser &&
            o.payment.method === method
        ))
      }
    },
    getReportByUserAndMethod() {
      return (deliveryUser, method) => {
        return this.getOrdersByUserAndMethod(deliveryUser, method).reduce((a, order) => {
          a.itemsAmount += order.totalAmount
          a.itemsAmountWithDiscount += (order.itemsAmount - order.totalDiscount)
          a.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
          a.totalAmount += order.totalAmount
          a.quantity += 1
          return a
        }, {quantity: 0, itemsAmount: 0, totalDiscount: 0, itemsAmountWithDiscount: 0, deliveryCost: 0, totalAmount: 0})
      }
    },

    getOrdersByMethod() {
      return (method) => {
        return this.orders.filter(o => (o.payment.method === method))
      }
    },
    getReportByMethod() {
      return (method) => {
        return this.getOrdersByMethod(method).reduce((a, order) => {
          a.itemsAmount += order.totalAmount
          a.itemsAmountWithDiscount += (order.itemsAmount - order.totalDiscount)
          a.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
          a.totalAmount += order.totalAmount
          a.quantity += 1
          return a
        }, {quantity: 0, itemsAmount: 0, totalDiscount: 0, itemsAmountWithDiscount: 0, deliveryCost: 0, totalAmount: 0})
      }
    },

    getReportByUser() {
      return deliveryUser => {

        let reports = [] //{method, quantity, amount}
        this.getOrdersByUser(deliveryUser).forEach(order => {
          let report = reports.find(r => r.method === order.payment.method)
          if (report) {
            report.quantity++
            report.itemsAmount += order.itemsAmount
            report.promoAmount += order.promoAmount
            report.totalDiscount += order.totalDiscount
            report.itemsAmountWithDiscount += (order.itemsAmount - order.totalDiscount)
            report.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
            report.totalAmount += order.totalAmount
          } else {
            reports.push({
              method: order.payment.method,
              user: deliveryUser,
              quantity: 1,
              itemsAmount: order.itemsAmount,
              promoAmount: order.promoAmount,
              totalDiscount: order.totalDiscount,
              itemsAmountWithDiscount: (order.itemsAmount - order.totalDiscount),
              deliveryCost: order.deliveryFree ? 0 : order.delivery.cost,
              totalAmount: order.totalAmount
            })
          }

        })

        return reports
      }
    },
    getOrdersQuantity() {
      return this.orders.length
    },
    getOrdersAmount() {
      return this.orders.reduce((a, o) => a + o.totalAmount, 0)
    },
    getOrdersQuantityByUser() {
      return deliveryUser => this.getOrdersByUser(deliveryUser).length
    },
    getOrdersAmountByUser() {
      return deliveryUser => this.getOrdersByUser(deliveryUser).reduce((a, o) => a + o.totalAmount, 0)
    },
    tablePrintItems() {
      let table = ''
      for (let row of this.boxRows) {
        table += `<tr>
                    <td style="text-align: center;font-size: 18px; border: 1px solid grey;">${row.concept}</td>
                    <td style="text-align: right;font-size: 18px; border: 1px solid grey;">${row.amount}</td>
                   </tr>`
      }

      return table
    },
    getTsShift() {
      return this.$t('delivery.shift.' + this.shift)
    },

  },
  methods: {
    createOrUpdateDailyBox() {
      this.dailyBox.boxDate = this.date
      this.dailyBox.shift = this.shift
      DailyBoxProvider.createOrUpdateDailyBox(this.dailyBox)
          .then(r => {
            console.error("DailyBox", r.data.createOrUpdateDailyBox)
          })
          .catch(e => {
            console.error(e)
          })
    },
    async fetch() {
      this.clearDailyBox()
      this.clearPreviousDailyBox()
      await this.fetchDailyBox()
      await this.fetchPreviousDailyBox()
      await this.fetchOrders()
    },
    clearDailyBox() {
      this.dailyBox = {
        boxDate: this.date,
        shift: this.shift,
        income: [],
        expenses: [],
        cashAtClose: 0,
      }
    },
    clearPreviousDailyBox() {
      this.previousDailyBox = {
        boxDate: this.previousDate,
        shift: this.previousShift,
        income: [],
        expenses: [],
        cashAtClose: 0,
      }
    },
    async fetchDailyBox() {
      console.log("Current  DailyBox", this.date.toISOString(), this.shift)
      try {
        const r = await DailyBoxProvider.findDailyBoxByDateAndShift(this.date, this.shift)
        this.clearDailyBox()
        let dailyBox = r.data.findDailyBoxByDateAndShift

        if (dailyBox && dailyBox.income) {
          this.dailyBox.income = dailyBox.income
        }
        if (dailyBox && dailyBox.expenses) {
          this.dailyBox.expenses = dailyBox.expenses
        }

        if (dailyBox && dailyBox.cashAtClose) {
          this.dailyBox.cashAtClose = dailyBox.cashAtClose
        }
      } catch (e) {
        console.error(e)
      }

    },
    async fetchPreviousDailyBox() {
      console.log("Previous DailyBox", this.previousDate.toISOString(), this.previousShift)
      try {
        const r = await DailyBoxProvider.findPreviousDailyBoxByDateAndShift(this.date, this.shift)
        this.clearPreviousDailyBox()
        let dailyBox = r.data.findPreviousDailyBoxByDateAndShift

        if (dailyBox && dailyBox.income) {
          this.previousDailyBox.income = dailyBox.income
        }
        if (dailyBox && dailyBox.expenses) {
          this.previousDailyBox.expenses = dailyBox.expenses
        }

        if (dailyBox && dailyBox.cashAtClose) {
          this.previousDailyBox.cashAtClose = dailyBox.cashAtClose
        }
      } catch (e) {
        console.error(e)
      }


    },
    removeIncome(index) {
      this.dailyBox.income.splice(index, 1)
      this.createOrUpdateDailyBox()

    },
    removeExpenses(index) {
      this.dailyBox.expenses.splice(index, 1)
      this.createOrUpdateDailyBox()
    },
    addIncome() {
      this.dailyBox.income.push({
        concept: '',
        amount: 0
      })
    },
    addExpense() {
      this.dailyBox.expenses.push({
        concept: '',
        amount: 0
      })
    },
    currentShift() {
      let now = Dayjs()
      if (now.hour() < 15) {
        this.shift = 'morning'
      } else {
        this.shift = 'afternoon'
      }
    },

    fetchOrders() {
      this.loading = true
      this.exportFile = null
      OrderProvider.orderFetchPaidBetweenDates(this.dateFrom, this.dateTo)
          .then(r => {
            this.orders = r.data.orderFetchPaidBetweenDates
          })
          .finally(() => this.loading = false)
    },
    cashAuditExport() {
      this.exportLoading = true
      CashAuditProvider.cashAuditExport(this.date)
          .then(r => {
            this.exportFile = r.data.cashAuditExport
          })
          .finally(() => this.exportLoading = false)
    },
    fetchOwnDelivery() {
      userProvider.usersByRole('repartidor').then(r => {
        this.ownDeliveryPeople = r.data.usersByRole
      })
    },
    fetchOutsourcedDelivery() {
      userProvider.usersByRole('repartidorTercerizado').then(r => {
        this.outsourcedDeliveryPeople = r.data.usersByRole
      })
    },

    print() {
      let printPreview = window.open('', 'print_preview');
      let printDocument = printPreview.document;
      printDocument.open();

      let head = "<head>" +
          "<style> .to-print{height:279mm; width:80mm; } </style>" +
          "</head>";
      let content = `
      <!DOCTYPE html>
      <html>${head}
      <body>
      <div class='to-print'>
      <h3 style="width: 100%;text-align: left; font-size: 26px; margin-bottom: 1px;">Arqueo de caja</h3>
      <span style="width: 100%;text-align: left; font-size: 20px;">${this.getDateFormat(this.date)} (${this.getTsShift})</span>
      <h3 style="width: 100%;text-align: left; font-size: 22px;">Efectivo</h3>
      <table style="width: 100%;text-align: left; font-size: 16px; border: 1px solid grey;">
        <thead>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;" >CONCEPTO</th>
            <th style="font-size: 18px; border: 1px solid grey; text-align: right">IMPORTE</th>
          </tr>
        </thead>
        <tbody>

          <tr>
            <td style="text-align: center;font-size: 18px; border: 1px solid grey;">Efectivo inicial de Caja</td>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.previousCashAtClose}</td>
          </tr>

        <tr>
          <td style="text-align: center;font-size: 18px; border: 1px solid grey;">Efectivo mostrador</td>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.cashOnBar}</td>
        </tr>

        ${this.tablePrintItems}



        <tr>
          <th style="font-size: 18px; border: 1px solid grey;">Total</th>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.getTotalCashAmount}</td>
        </tr>

        <tr>
          <th style="font-size: 18px; border: 1px solid grey;">Efectivo en caja (Cierre)</th>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.dailyBox.cashAtClose}</td>
        </tr>

        <tr>
          <th style="font-size: 18px; border: 1px solid grey;">Diferencia</th>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.dailyBox.cashAtClose - this.getTotalCashAmount}</td>
        </tr>

        </tbody>
      </table>

      <br>
    <h3 style="width: 100%;text-align: left; font-size: 22px;">Electronico</h3>
      <table style="width: 100%;text-align: left; font-size: 16px; border: 1px solid grey;">
      <thead>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;" >CONCEPTO</th>
            <th style="text-align: center; font-size: 18px; border: 1px solid grey; text-align: center">C</th>
            <th style="text-align: right; font-size: 18px; border: 1px solid grey; text-align: right">IMPORTE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Debito</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.debito.quantity}</td>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.debito.totalAmount}</td>
          </tr>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Transferencias Bancarias</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaBancaria.quantity}</td>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaBancaria.totalAmount}</td>
          </tr>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Transferencias Mercado Pago</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaMercadoPago.quantity}</td>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaMercadoPago.totalAmount}</td>
          </tr>

          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Rappi</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaRappi.quantity}</td>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaRappi.totalAmount}</td>
          </tr>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">PedidosYa</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaPedidosYa.quantity}</td>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.transferenciaPedidosYa.totalAmount}</td>
          </tr>

          </tbody>
        </table>

      <br><br><br><br>
      </div>
      </body></html>
      `
      printDocument.write(content);
      printPreview.print();
      printPreview.close()
    }
  }
}
</script>

<style scoped>
.red-label .v-label {
  color: red !important;
  opacity: 1;
}

.blue-label .v-label {
  color: blue !important;
  opacity: 1;
}

</style>
